import type { ModuleFederationRuntimePlugin } from '@module-federation/enhanced/runtime';

/**
 * Federation preloads and Rspack dynamic loads must use the same CORS mode so
 * the browser cannot reuse an incompatible cached response for the same URL.
 */
const anonymousCorsPlugin = () =>
  ({
    name: 'anonymous-cors-plugin',
    createScript(args) {
      (args.attrs ??= {}).crossorigin = 'anonymous';
    },
    createLink(args) {
      if (args.attrs?.as !== 'script') {
        return;
      }
      args.attrs.crossorigin = 'anonymous';
    },
  }) satisfies ModuleFederationRuntimePlugin;

export default anonymousCorsPlugin;
